<div class="remote-control-view-container">
  <app-toast id="rc-toast" class="toast-bar" [toast]="toast"></app-toast>
  <div class="tab-views-wrapper" [ngClass]="{ 'right-margin': showRightMargin() }" [hidden]="!tabViewVisible()">
    <app-rc-tab-selector class="tab-selector" [deviceId]="getDeviceId()">
      <app-rc-tab-view class="tab-view" (onTabShow)="showCanvas()" (onTabHide)="hideCanvas()">
        <div id="rc-view" style="height: 100%">
          <div #canvasOuter id="canvasOuter" [hidden]="isVideoStreamingSupported === true">
            <xs-remote-control-canvas
              app-remote-control-canvas-directive
              #tabcontent
              class="remote-control-canvas"
              [supportsInput]="supportsInput()"
              (onCanvasReady)="setRcCanvasReady()"
            >
            </xs-remote-control-canvas>
          </div>
          <div #videoOuter id="videoOuter" [hidden]="isVideoStreamingSupported === false">
            <xs-remote-control-screen-panel
              [supportsInput]="supportsInput()"
              (onCanvasReady)="setRcCanvasReady()"
              [popOut]="popOut"
            >
            </xs-remote-control-screen-panel>
          </div>
          <div>
            <xsight-multi-selection-view
              class="selection-view"
              [rcState]="rcState"
              [canvasWidth]="canvasOuter?.clientWidth"
              [canvasHeight]="canvasOuter?.clientHeight"
              [screenWidth]="deviceContext?.canvas?.width"
              [screenHeight]="deviceContext?.canvas?.height"
              [screenLeft]="deviceContext?.left"
              [screenTop]="deviceContext?.top"
              [availableDisplays]="availableDisplays"
              (isInVisualSelectionMode)="showVisualSelection($event)"
              [hidden]="inVisualSelectionMode === false || isLatestWindowsModernAgent === false"
            ></xsight-multi-selection-view>
          </div>
        </div>
      </app-rc-tab-view>
      <app-rc-tab-view class="tab-view"></app-rc-tab-view>
      <app-rc-tab-view class="tab-view"></app-rc-tab-view>
      <app-rc-tab-view class="tab-view">
        <div id="rc-view" *ngIf="isFileExplorerAvailable()">
          <app-file-explorer #tabcontent></app-file-explorer>
        </div>
      </app-rc-tab-view>
      <app-rc-tab-view class="tab-view">
        <div id="rc-view" *ngIf="isTaskManagerAvailable()">
          <app-task-manager #tabcontent [deviceState]="rcState"></app-task-manager>
        </div>
      </app-rc-tab-view>
    </app-rc-tab-selector>
  </div>

  <div class="rc-bars-container">
    <!-- the blue bar on the right -->
    <ng-template #actionBar>
      <!--does not render here, will render in the workpanel -->
      <!-- the white bar on the right, only for remote control tab -->
      <div class="rc-action-bar" [hidden]="!showRcActionbar()">
        <app-rc-zoom class="rc-bar-icon" [rcState]="rcState"> </app-rc-zoom>

        <div class="hd-icon rc-bar-icon" *ngIf="isClientSideRotationEnabled()">
          <app-remote-control-device-rotation
            class="action-bar-button"
            [soti-tooltip]="'remoteControl_btn_RotateClockwise' | xsI18n"
            placement="left"
          >
          </app-remote-control-device-rotation>
        </div>

        <app-rc-screenshot *ngIf="isScreenshotEnabled" [rcState]="rcState" [standAlone]="standAlone" [popOut]="popOut">
        </app-rc-screenshot>

        <app-remote-control-video-recording-popover
          *ngIf="isVideoRecordingEnabled"
          class="rc-video-recording-popover"
          [rcState]="rcState"
        >
        </app-remote-control-video-recording-popover>

        <div
          *ngIf="isAnnotationEnabled"
          [soti-tooltip]="
            (isAnnotationAllowed ? 'remoteControl_btn_EnableScreenDrawing' : 'permissions_insufficient_user_rights')
              | xsI18n
          "
          placement="left"
          class="hd-icon hd-icon-guide-user icon-lg rc-bar-annotation"
          [class.rc-icon-higlighter-active]="isAnnotating"
          [class.button-disabled]="isAnnotationPendingAccept || !isAnnotationAllowed"
          (click)="toggleAnnotations()"
        ></div>

        <div class="hd-icon rc-bar-icon">
          <div
            *ngIf="isMultiDisplayAvailable && !isLatestWindowsModernAgent"
            #multiDisplayPopupTrigger
            [sotiPopupTriggerFor]="multiDisplayPopup"
            [popUpDisableClick]="isActiveRecording"
            [soti-tooltip]="
              isActiveRecording
                ? 'Cannot switch the display screen while recording video'
                : ('display_screen_title' | xsI18n)
            "
            placement="left"
            (popUpOpened)="fetchAvailableDisplays()"
            (popUpClosed)="clearDisplays()"
            class="hd-icon rc-bar-multiDisplay"
            [class.rc-multi-screen-item-disabled]="isActiveRecording"
            [class.rc-multi-screen-highlighter-active]="isDualScreenPopupOpen"
            [class.rc-multi-screen-darkMode]="isDarkMode"
          >
            <img class="non-visual" src="./assets/images/icon-displayscreen.svg" />
          </div>

          <div
            *ngIf="isMultiDisplayAvailable && isLatestWindowsModernAgent"
            [soti-tooltip]="
              (isActiveRecording ? 'remoteControl_DisabledWhileRecording_Message' : 'display_screen_title')
              | xsI18n
            "
            placement="left"
            (click)="showVisualSelection({ inVisualMode: true, monitorInfo: availableDisplays[0] })"
            class="hd-icon rc-bar-multiDisplay"
            [class.rc-multi-screen-item-disabled]="isActiveRecording"
            [class.rc-multi-screen-darkMode]="isDarkMode"
          >
            <img class="visual" src="{{ 'icon-visual-selection.svg' | xsImage }}" />
          </div>
        </div>

        <soti-popup #multiDisplayPopup="sotiPopup" position="endCenter" [noFallback]="true">
          <xsight-multi-display-popup
            *ngIf="!!activeDisplay"
            #multiDisplayPopup
            [activeDisplay]="activeDisplay"
            [availableDisplays]="availableDisplays"
            (itemSelected)="displaySelected($event)"
            [getPopupTrigger]="getPopupTrigger"
          ></xsight-multi-display-popup>
        </soti-popup>

        <div class="hd-icon rc-bar-icon">
          <app-remote-control-user-preferences
            class="action-bar-button"
            [soti-tooltip]="'remoteControl_btn_UserPreferences' | xsI18n"
            placement="left"
            [isVideoRecordingDisabled]="!allowServerSideRecording()"
            [isScreenSettingsVisible]="isScreenSettingsVisible()"
          >
          </app-remote-control-user-preferences>
        </div>
      </div>

      <div class="rc-action-bar" [hidden]="!showDeviceButtons()">
        <app-device-buttons
          class="rc-bar-icon"
          *ngIf="supportsInput()"
          [rcState]="rcState"
          (showDeviceButtons)="toggleShowDeviceButtons($event)"
        >
        </app-device-buttons>
      </div>

      <ng-container *ngIf="showFileManagerButtons()">
        <div class="rc-action-bar" [hidden]="!showFileManagerButtonsToggle">
          <app-file-manager-buttons
            class="rc-bar-icon"
            [rcState]="rcState"
            (showFileManagerButtons)="toggleShowFileManagerButtons($event)"
          >
          </app-file-manager-buttons>
        </div>
      </ng-container>
    </ng-template>

    <ng-template #actionBarLegacyDeviceInfo>
      <!--does not render here, will render in the workpanel -->
      <div class="rc-action-bar" [hidden]="!showLegacyDeviceInfoActionBar()">
        <div class="action-bar-button device-info-bar-button" (click)="refreshLegacyDeviceInfo()">
          <div
            class="hd-icon hd-icon-refresh icon-lg rc-bar-icon"
            [soti-tooltip]="'deviceInfo_Refresh_DeviceInfo' | xsI18n"
            placement="left"
          ></div>
        </div>
      </div>
    </ng-template>
  </div>
  <app-remote-control-extended-toolbar
    [ngClass]="{ 'offset-scroll-area': isHorizontalScrollbarEnable, 'offset-hidden': isAnnotationBarHidden }"
    *ngIf="showAnnotationToolbar"
    [rcState]="rcState"
  >
  </app-remote-control-extended-toolbar>

  <div class="error-screen-container" [hidden]="!rcHasError()">
    <div class="error-screen-content">
      <img
        class="connection-lost-image"
        src="./assets/images/ConnectionLost.svg"
        alt="{{ 'remoteControl_alt_text_connection_lost_to_device' | xsI18n }}"
      />
      <div class="error-screen-title">{{ getErrorMessageCaption() }}</div>
      <div class="error-screen-message">{{ getErrorMessageDescription() }}</div>
      <button class="xs-btn btn-primary btn-connect-again" (click)="restartRc($event)" type="button">
        <span>{{ 'ticket_RemoteControl_ConnectAgain' | xsI18n }}</span>
      </button>
    </div>
  </div>

  <div class="error-screen-container" [hidden]="!showConnectionScreen()">
    <div class="error-screen-content info-content">
      <ng-container *ngIf="canRcWithoutNotification || !knowsPermissions; else elseTemplate">
        <img
          class="connection-pending-image"
          src="./assets/images/ConnectingGeneral.svg"
          alt="Connecting to the device"
        />
        <!-- alt="{{ 'remoteControl_alt_text_connecting_general' | xsI18n }}""-->
        <div class="error-screen-title">{{ 'remoteControl_connecting_general_title' | xsI18n }}</div>
        <div class="error-screen-message">{{ 'remoteControl_connecting_general_description' | xsI18n }}</div>
      </ng-container>
      <ng-template #elseTemplate>
        <img
          class="connection-pending-image"
          src="./assets/images/ConnectingPermissionRequired.svg"
          alt="Connecting to the device"
        />
        <!-- alt="{{ 'remoteControl_alt_text_connecting_permission_required' | xsI18n }}"-->
        <div class="error-screen-title">{{ 'remoteControl_connecting_general_title' | xsI18n }}</div>
        <div class="error-screen-message">
          {{ 'remoteControl_connecting_permission_required_description' | xsI18n }}
        </div>
      </ng-template>
    </div>
  </div>
</div>

<!--
  The curtain (mask area) used to cover buttons when RC is in the multi-display visual selection mode
  For full mask area, please check multi-display-selection-view component
-->
<div *ngIf="inVisualSelectionMode && workPanelHeight < workPanelBarContainerHeight"
  class="rc-multi-view-mask-area"
  [ngStyle]="{
    'height': (workPanelBarContainerHeight - workPanelHeight + 2) + 'px',
    'top': (workPanelHeight - 2) + 'px',
  }">
</div>

<ng-template #titleBar>
  <!--does not render here, will render in the workpanel -->
  <app-rc-title-bar
    [isLicenceActive]="isLicenceActive"
    [standAlone]="standAlone"
    [workPanelKey]="currentWorkPanelKey"
    [showControls]="standAlone"
    [deviceState]="rcState"
    [rcTabTitle]="getCurrentRcPanelTitle()"
    [snapshotRefreshInProgress]="snapshotRefreshInProgress"
  ></app-rc-title-bar>
</ng-template>
